import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Spinner } from "@fluentui/react-components";
import { AuthGuard } from "../auth/AuthGuard";
import { useOkta } from "../auth/OktaProvider";

function IndexInner() {
  const { isAuthenticated } = useOkta();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      void navigate({ to: "/briefs/new", replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <Spinner label="Chargement..." />;
}

export function IndexRoute() {
  return (
    <AuthGuard fallback={<Spinner label="Redirection vers Okta..." />}>
      <IndexInner />
    </AuthGuard>
  );
}
